import React from "react";
import {Routes, Route} from "react-router-dom";
import Home from "../pages/Home";
import Infrastructure from "../pages/Infrastructure";
import Services from "../pages/Services";
import Actualities from "../pages/Actualities";     
import Contact from "../pages/Contact";
import Legals from "../pages/Legals";
import NotFound from "../pages/NotFound";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import CookiePopup from "../components/CookiePopup";

function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    const consent = document.cookie.includes("userConsentGA=true");
    if (consent && window.gtag) {
      window.gtag('event', 'page_view', { page_path: location.pathname });
    }
  }, [location]);
}

const Main = () => {
    usePageTracking(); 
    return (
      <>
        <CookiePopup/>
        <Routes>
            <Route exact path="/" element={<Home/>}/>
            <Route exact path="/infrastructures" element={<Infrastructure/>} />
            <Route exact path="/pensions" element={<Services/>} />
            <Route exact path="/actualites" element={<Actualities/>} />
            <Route exact path="/contact" element={<Contact/>} />
            <Route exact path="/mentions" element={<Legals/>} />
            <Route exact path="*" element={<NotFound/>} />
        </Routes>
      </>
    );
}

export default Main;